import { useState, useEffect } from 'react';
import { useAuth } from './hooks/useAuth';
import { login, getMe } from './lib/api';
import LoginForm from './components/LoginForm';
import Dashboard from './components/Dashboard';
import Header from './components/Header';

function App() {
  const { user, loading, login: authLogin, logout } = useAuth();
  const [loginError, setLoginError] = useState('');

  const handleLogin = async (username: string, password: string) => {
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      const data = await res.json();

      if (res.ok) {
        authLogin(data.token, data.data.user);
      } else {
        setLoginError(data.error || 'Login failed');
      }
    } catch (error) {
      setLoginError('Network error');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-dark-200">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark-200">
      <Header user={user} onLogout={logout} />
      <main className="container mx-auto px-4 py-8">
        {user ? (
          <Dashboard user={user} />
        ) : (
          <LoginForm onLogin={handleLogin} error={loginError} />
        )}
      </main>
    </div>
  );
}

export default App;
